import { PressableProps, ViewStyle } from 'react-native';
import { Styles } from '../../types/styles';
import { BoxProps } from '../Box/Box.types';
import { IconProps } from '../Icon/Icon.types';
import { TextProps } from '../Text/Text.types';

export type ButtonVariants = 'primary' | 'secondary' | 'tertiary';

export enum ButtonSizes {
  inline = 'inline',
  small = 'small',
  large = 'large',
}

export type ButtonProps = Styles<ViewStyle> &
  Pick<PressableProps, 'onPress'> & {
    variant?: `${ButtonVariants}`;
    size?: `${ButtonSizes}`;
    light?: boolean;
    text?: string;
    locKey?: TextProps['locKey'];
    locNS?: TextProps['locNS'];
    loading?: boolean;
    disabled?: boolean;
    leftIcon?: IconProps['name'];
    rightIcon?: IconProps['name'];
    trackingId?: string;
  };

export type SizesConfig = Record<
  ButtonSizes,
  Pick<BoxProps, 'width' | 'height' | 'paddingHorizontal' | 'gap'>
>;
